import React, { useState, useEffect } from "react";
import axios from "axios";
import { Loading } from 'react-simple-chatbot';
import { API_URL } from '../constant'

const FetchAnswer = ({ steps, triggerNextStep }) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState("");
  const [isErrror, setIsError] = useState(false);

  const searchApi = async() => {
    const profileValue =  steps.optionsProfile.value;
    const profile = profileValue === 'custom' ? steps.userInputProfile.value : profileValue;
    const userQuestion = steps.userInputQuestion.value;

    setIsError(false)
    setLoading(true);
    try {
      let question = userQuestion
      if(profileValue!=='all') {
        question = `Sobre el siguiente perfil: ${profile}. ${userQuestion}`
      }

      const params = {
        //sessionIdKB: localStorage.getItem('sessionIdKB'),
        question
      }
      const { data } = await axios.post(API_URL, params)
      setResponse(data.value);
      localStorage.setItem('sessionIdKB', data.sessionIdKB)
      setLoading(false);
      setTimeout(() => triggerNextStep(), 1000);
    } catch (error) {
      console.error(error)
      setIsError(true)
      setLoading(false);
    }
  }

  useEffect(() => {
    searchApi()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (<div>
    {loading ? <Loading/> : response}
    {!loading && isErrror && 
      <div className="error-response">
        <div>Falló la solicitud</div>
        <button onClick={() => searchApi()}>Reintentar</button>
      </div>
    }
  </div>);
};

export default FetchAnswer